import axios from 'axios'
const urlBefore = 'https://www.iformats.cn/smg'
// 轮播大图请求
export const advertisementRequest = (dataObj) => axios.request({
  url: urlBefore + `/advertisement/fetchAdvertisementData?lang=${dataObj.lang}`,
  cache: false,
  method: 'get'
})
// 最新资讯
export const newsRequest = (dataObj) => axios.request({
  url: urlBefore + `/news/fetch?lang=${dataObj.lang}&pageNum=${dataObj.pageNum}&pageSize=${dataObj.size}`,
  cache: false,
  //   data: dataObj,
  method: 'get'
})
// 首页主内容
export const homePageRequest = (dataObj) => axios.request({
  url: urlBefore + `/homePage/content?lang=${dataObj.lang}`,
  cache: false,
  data: dataObj,
  method: 'get'
})
// 合作伙伴
export const parnerRequest = (dataObj) => axios.request({
  url: urlBefore + `/parner/fetch?offset=${dataObj.offset}`,
  cache: false,
  data: dataObj,
  method: 'get'
})
// 详情页列表
export const detailListRequest = (dataObj) => axios.request({
  url: urlBefore + `/programMode/fetchProgramMode`,
  //   ?category=${dataObj.category}&lang=${dataObj.offset}&platform=${dataObj.offset}&area=${dataObj.area}&year=${dataObj.year}&query=${dataObj.query}&page=${dataObj.page}`,
  cache: false,
  data: dataObj,
  method: 'post'
})
// 详情页列表
export const categoryRequest = (dataObj) => axios.request({
  url: urlBefore + `/category/fetch`,
  cache: false,
  params: dataObj,
  method: 'get'
})
// 详情页列表
export const newsDetailRequest = (dataObj) => axios.request({
  url: urlBefore + `/news/fetchNewsDetail`,
  cache: false,
  params: dataObj,
  method: 'get'
})
// 模式详情页
export const programModeRequest = (dataObj) => axios.request({
  url: urlBefore + `/programMode/fetchProgramModeDetail`,
  cache: false,
  params: dataObj,
  method: 'get'
})
// 赛事列表页
export const matchListRequest = (dataObj) => axios.request({
  url: urlBefore + `/matchMode/listQuery`,
  //   ?category=${dataObj.category}&lang=${dataObj.offset}&platform=${dataObj.offset}&area=${dataObj.area}&year=${dataObj.year}&query=${dataObj.query}&page=${dataObj.page}`,
  cache: false,
  data: dataObj,
  method: 'post'
})
// 赛事详情页
export const matchModeRequest = (dataObj) => axios.request({
  url: urlBefore + `/matchMode/fetch/${dataObj.id}`,
  cache: false,
  params: dataObj,
  method: 'get'
})
// 注册
export const registModeRequest = (dataObj) => axios.request({
  url: urlBefore + `/user/regist`,
  cache: false,
  data: dataObj,
  method: 'post'
})
// 登录
export const loginModeRequest = (dataObj) => axios.request({
  url: urlBefore + `/user/login`,
  cache: false,
  data: dataObj,
  method: 'post'
})
// 报告列表
export const reportListRequest = (dataObj) => axios.request({
  url: urlBefore + `/report/fetchReportPage`,
  cache: false,
  params: dataObj,
  method: 'get'
})
// 报告详情
export const reportListDetailRequest = (dataObj) => axios.request({
  url: urlBefore + `/report/fetchReportDetail?id=${dataObj.id}&lang=${dataObj.lang}`,
  cache: false,
  method: 'get'
})
// 自定义列表
export const selfListRequest = (dataObj) => axios.request({
  // ?lang=${dataObj.lang}&contentType=${dataObj.contentType}&id=${dataObj.id}
  url: urlBefore + `/customMode/fetch`,
  cache: false,
  params: dataObj,
  //   params: dataObj,
  method: 'get'
})
// 自定义列表详情
export const perListDetailRequest = (dataObj) => axios.request({
  url: urlBefore + `/customMode/fetchCustomModeDetail?lang=${dataObj.lang}&id=${dataObj.id}`,
  cache: false,
  //   params: dataObj,
  method: 'get'
})
// 模式研究院
// export const modelListRequest = (dataObj) => axios.request({
//     url: urlBefore + `/customMode/fetch?lang=${dataObj.lang}&pageNum=${dataObj.pageNum}&size=${dataObj.pageSize}`,
//     cache: false,
//     params: dataObj,
//     method: 'get'
// })
// 菜单列表
export const modelListRequest = (dataObj) => axios.request({
  url: urlBefore + `/content/fetch?lang=${dataObj.lang}`,
  cache: false,
  method: 'get'
})
// 报告下载
export const reportLinkRequest = (dataObj) => axios.request({
  headers: { 'authorization': localStorage.tokenVal, 'userId': localStorage.userVal, 'token': localStorage.userVal },
  url: urlBefore + `/userReport/fetch?reportId=${dataObj.reportId}&userId=${localStorage.userVal}`,
  cache: false,
  data: dataObj,
  method: 'get'
})
export const reportDownloadRequest = (dataObj) => axios.request({
  headers: { 'authorization': localStorage.tokenVal, 'userId': localStorage.userVal, 'token': localStorage.userVal },
  url: urlBefore + `/userReport/save`,
  cache: false,
  data: dataObj,
  method: 'post'
})
// 全局搜索
export const allSearchRequest = (dataObj) => axios.request({
  headers: { 'authorization': localStorage.tokenVal, 'userId': localStorage.userVal, 'token': localStorage.userVal },
  url: urlBefore + `/homePage/query?lang=${dataObj.lang}&query=${dataObj.query}`,
  cache: false,
  // data: dataObj,
  method: 'get'
})
// 提交评论
export const commentRequest = (dataObj) => axios.request({
  headers: { 'authorization': localStorage.tokenVal, 'userId': localStorage.userVal, 'token': localStorage.userVal },
  url: urlBefore + `/comment/save`,
  cache: false,
  data: dataObj,
  method: 'post'
})
// 评论列表
export const fetchCommentRequest = (dataObj) => axios.request({
  headers: { 'authorization': localStorage.tokenVal, 'userId': localStorage.userVal, 'token': localStorage.userVal },
  url: urlBefore + `/comment/fetchCommentPage?pageNum=${dataObj.pageNum}&pageSize=${dataObj.pageSize}&status=1&modeId=${dataObj.modeId}`,
  cache: false,
  // data: dataObj,
  method: 'get'
})
